"use client";

import { useEffect } from "react";
import { useTracker } from "@huub-web/ui";
import { isWindowDefined } from "@huub-web/utils";

import { useNavigate } from "../../hooks";

/**
 * Track route changes
 */
export function RouteChangeTracker() {
  const { location } = useNavigate();
  const { track } = useTracker();

  useEffect(() => {
    if (!isWindowDefined()) {
      return;
    }
    track("pageView", {
      pagePath: location.pathname,
      pageTitle: document.title,
      properties: {
        search: location.search,
        hash: location.hash,
      },
    });
  }, [location, track]);

  return null;
}
